import { filtersEpics } from './filters/filters.epics';
import { productsEpics } from './products/products.epics';
import tagsEpics from './tags/tags.epics';

export default [...filtersEpics, ...productsEpics, ...tagsEpics];
